import { withRouter } from 'react-router';

import SubscribeLayout from '../components/SubscribeLayout.jsx';

export default withRouter(SubscribeLayout);
